const MAIN = "6770fe4400025c7f2afb"
export {
  MAIN
}